import { HttpClient } from '@angular/common/http';
import { CacheService } from '../cache';
import { ResourceService } from './resource';
import { IRoom, Room } from '../../models';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoomService extends ResourceService<Room> {
   /**
    * @constructor 
    * Creates an instance of the RoomService 
    *
    * @param {HttpClient} http Injected instance of HttpClient
    * @param {CacheService} cache Injected instance of CacheService
  */
  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache,  'rooms');
  }

   /**
  * 
  * @remarks 
  * to sets a parentId on the ResourceService instance, to effectively mutate the endpoint
  * and act as a sub/child resource instance
  * 
  * @param {string} parentId A unique identifier for the parent resource
  * @returns {this} Returns an instance of the class so the method can be chained.
  */
  public setParent(propertyId: string) {
    this.endpoint = `properties/${propertyId}/rooms`;
    return this;
  }

   /**
    * Sends a PUT request to the /rooms/:id/visibility endpoint
    * @remarks
    * to publish or unpublish a single room.
    *
    * @param {published: boolean, id: string } item The unique identifier used to create a channel 
    * @returns {Observable} Returns an observable
  */
  public publish(item: { published: boolean, id: string }) {
    const { published } = item;
    return this.http.put(`${this.endpoint}/${item.id}/visibility`, { published }).pipe(map(resp => {
      this.cache.remove(`${this.endpoint}/${item.id}`);
      this.cache.remove(`${this.endpoint}`);
      return resp;
    }))
  }

}
